import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sprout } from "lucide-react";
import { api } from "@/lib/api";
import { logError } from "@/lib/log";
import { GardenScene } from "@/components/garden/GardenScene";

// Small preview of this month's garden on Home
export const GardenPreview = () => {
  const [g, setG] = useState(null);
  useEffect(() => { api.get("/garden/summary").then((r) => setG(r.data)).catch((e) => logError("Garden summary failed:", e)); }, []);
  if (!g) return null;
  const n = g.counts.flowers;
  return (
    <Link to="/garden" className="mm-card overflow-hidden block group mb-6" data-testid="home-garden-preview">
      <div className="h-40 overflow-hidden relative"><div className="absolute inset-x-0 bottom-0"><GardenScene data={{ ...g, months: [] }} className="origin-bottom group-hover:scale-[1.03] transition-transform duration-500" /></div></div>
      <div className="p-4 flex items-center justify-between gap-3">
        <div>
          <div className="font-semibold flex items-center gap-2"><Sprout size={18} className="text-mm-primary" />My {g.month_name} garden</div>
          <div className="text-sm text-mm-muted">{n ? `${n} flower${n === 1 ? "" : "s"} planted so far` : "Check in to plant your first flower"}</div>
        </div>
        <span className="text-sm text-mm-primary font-medium shrink-0">Visit →</span>
      </div>
    </Link>
  );
};
